import RecServiceCarousel from 'components/RecServiceCarousel/RecServiceCarousel';

export default RecServiceCarousel;
